import React from "react";
import NewJobPostedCard from "./NewJobPostedCard";
import ReferralMilestoneCard from "./ReferralMilestoneCard";
import PlacementConfirmedCard from "./PlacementConfirmedCard";
import TierUpgradeCard from "./TierUpgradeCard";
import LeaderboardChampionCard from "./LeaderboardChampionCard";
import EditorialCard from "./EditorialCard";
import WeeklyStatsCard from "./WeeklyStatsCard";
import TrendingRoleCard from "./TrendingRoleCard";
import CandidateMatchAlertCard from "./CandidateMatchAlertCard";

/**
 * FeedCardDispatcher — reads card.type and renders the right component.
 *
 * Card types (PRD §5.1 + §5.2):
 *   new_job_posted       → NewJobPostedCard
 *   referral_milestone   → ReferralMilestoneCard
 *   placement_confirmed  → PlacementConfirmedCard
 *   tier_upgrade         → TierUpgradeCard
 *   leaderboard_champion → LeaderboardChampionCard
 *   weekly_stats         → WeeklyStatsCard
 *   trending_role        → TrendingRoleCard
 *   candidate_match      → CandidateMatchAlertCard
 *   editorial            → (Sprint 2 — to be implemented)
 *
 * Unknown card types render a generic fallback so the feed never breaks.
 */
const FeedCardDispatcher = ({ card }) => {
  switch (card.type) {
    case "new_job_posted":
      return <NewJobPostedCard card={card} />;
    case "referral_milestone":
      return <ReferralMilestoneCard card={card} />;
    case "placement_confirmed":
      return <PlacementConfirmedCard card={card} />;
    case "tier_upgrade":
      return <TierUpgradeCard card={card} />;
    case "leaderboard_champion":
      return <LeaderboardChampionCard card={card} />;
    case "editorial":
      return <EditorialCard card={card} />;
    case "weekly_stats":
      return <WeeklyStatsCard card={card} />;
    case "trending_role":
      return <TrendingRoleCard card={card} />;
    case "candidate_match":
      return <CandidateMatchAlertCard card={card} />;
    default:
      // Generic fallback — never break the feed on an unknown card type
      return (
        <div style={styles.fallback}>
          <p style={styles.fallbackText}>{card.title || card.preview_text}</p>
        </div>
      );
  }
};

const styles = {
  fallback: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    marginBottom: "16px",
    padding: "20px",
  },
  fallbackText: {
    fontSize: "14px",
    color: "#64748b",
    margin: 0,
  },
};

export default FeedCardDispatcher;
